module.exports = "<div class=\"main-content\">\n  <app-history class=\"app-container\" [origin]=\"origin\" [idEntity]=\"idEntity\"></app-history>\n</div>"